import { render, staticRenderFns } from "./registrationStatusLeave.vue?vue&type=template&id=defb234e&"
import script from "./registrationStatusLeave.vue?vue&type=script&lang=js&"
export * from "./registrationStatusLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports